import { Badge, Card, CardBody, Col, Modal } from "reactstrap";
import { H5, Image, LI, SVG, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { Link } from "react-router-dom";
import { BALANCE_DATA } from "../../../../../Data/UiKit/Modal";
import { BalanceModalProp } from "../../../../../Type/UiKits";
import { BalanceAmount, YourBalance } from "../../../../../Constant";

export const BalanceModal = ({ modalThird, modalThirdTogggle }: BalanceModalProp) => {
  return (
    <Modal centered fade isOpen={modalThird} toggle={modalThirdTogggle}>
      <Col xl="12">
        <Card className="balance-box mb-0">
          <CardBody>
            <div className="balance-profile">
              <div className="balance-img">
                <Image className="image-fluid" src={dynamicImage("dashboard/user.png")} alt="user vector" />
                <Link className="edit-icon" to={`${process.env.PUBLIC_URL}/users/user-profile`}><SVG iconId="pencil" /></Link>
              </div>
              <span className="f-light d-block">{YourBalance}</span>
              <H5 className="mt-1">{BalanceAmount}</H5>
              <UL className="simple-list d-flex flex-row">
                {BALANCE_DATA.map(({ title, text, data, icon, color }, index) => (
                  <LI key={index}>
                    <div className={`balance-item ${color}`}>
                      <div className="balance-icon-wrap"><div className="balance-icon">{icon}</div></div>
                      <div>
                        <span className="f-12 f-light">{title}</span><H5
                        >{text}</H5><Badge color={`light-${color}`} className={`rounded-pill text-${color}`}>{data}</Badge>
                      </div>
                    </div>
                  </LI>
                ))}
              </UL>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Modal>
  );
};
